import React from "react";
import { useFormikContext, FastField } from "formik";
import { Row, Col, Form } from "react-bootstrap";
import { QuotationFormValues } from "../initialValues";
import { ServiceQuotationFormValues } from "../serviceInitialValues";
import { MecordColors } from "Constants/Color";

const AgentDetailsSection: React.FC = () => {
  const { values } = useFormikContext<QuotationFormValues | ServiceQuotationFormValues>();

  const disabled = Boolean((values as any).has_order || (values as any).sales_order_service_id);

  return (
    <div
      className="rounded mb-3"
      >
      <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
        <h5 className="fw-semibold">
          Agent Details
        </h5>
      </div>

      <Row className="g-3 pb-3 px-1 rounded"
        // style={{ backgroundColor: MecordColors?.LightGrayColor }}
      >
        <Col xs={12} md={12}>
          <Form.Group>
            <Form.Label>Agent Name</Form.Label>
            <FastField name="agent_name">
              {({ field }: any) => (
                <Form.Control
                  {...field}
                  placeholder="Enter Agent Name"
                  disabled={disabled}
                />
              )}
            </FastField>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default AgentDetailsSection;
